
import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot
} from '@angular/router';
import { AuthService } from './auth.service';
@Injectable()
export class RoleGuardService implements CanActivate {

  constructor(public auth: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const expectedRoles = route.data.expectedRole;
    const role = this.auth.getUserRole();
    if (expectedRoles.find(r => r === role)) {
      return true;
    } else {
      this.router.navigate(['locations']);
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/role-guard.service.ts